class PreviewUploadTest {
  constructor() {
    this.flag = Signalman.featureFlag('preview_upload_v9');
    this.fireMetrics();
  }

  fireMetrics() {
    return CustomInk.Metrics.fireEvent(
      'testing',
      '2024 11 07 catalog upload preview',
      `2024 11 07 catalog upload preview ${this.flag}`
    );
  }
}

ProductCatalog.PreviewUploadTest = new PreviewUploadTest();
